export default {"src":"/polygon/_next/static/media/fantom.b41750a8.svg","height":14,"width":8};